"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TextHighlighter", {
  enumerable: true,
  get: function () {
    return _TextHighlighter.default;
  }
});
exports.default = void 0;
var _TextHighlighter = _interopRequireDefault(require("./TextHighlighter"));
var _default = exports.default = _TextHighlighter.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfVGV4dEhpZ2hsaWdodGVyIiwiX2ludGVyb3BSZXF1aXJlRGVmYXVsdCIsInJlcXVpcmUiLCJfZGVmYXVsdCIsImV4cG9ydHMiLCJkZWZhdWx0IiwiVGV4dEhpZ2hsaWdodGVyIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGV4dEhpZ2hsaWdodGVyL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBUZXh0SGlnaGxpZ2h0ZXIsIHsgVGV4dEhpZ2hsaWdodGVyUHJvcHMgfSBmcm9tIFwiLi9UZXh0SGlnaGxpZ2h0ZXJcIlxuXG5leHBvcnQgdHlwZSB7IFRleHRIaWdobGlnaHRlclByb3BzIH1cbmV4cG9ydCB7IFRleHRIaWdobGlnaHRlciB9XG5leHBvcnQgZGVmYXVsdCBUZXh0SGlnaGxpZ2h0ZXJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBLElBQUFBLGdCQUFBLEdBQUFDLHNCQUFBLENBQUFDLE9BQUE7QUFBeUUsSUFBQUMsUUFBQSxHQUFBQyxPQUFBLENBQUFDLE9BQUEsR0FJMURDLHdCQUFlIiwiaWdub3JlTGlzdCI6W119